import { EventEmitter } from 'events';

// Create a global event emitter to handle custom events
const emitter = new EventEmitter();

/**
 * Current events fired in the application
 * ORGANIZATION_DELETED: Fired when user deletes an organization
 * USER_UPDATED: Fired when user updates some field in account settings
 */

export default emitter;